type Props = {
  text: string
  count: number
  recordBlockBgColor: string
  recordBlockTextColor: string
}

export function GameCollectionRecordBlock(props: Props) {
  const { text, count, recordBlockBgColor, recordBlockTextColor } = props

  return (
    <div
      className="h-[92px] rounded-lg pt-2"
      style={{
        backgroundColor: recordBlockBgColor,
      }}
    >
      <p
        className="text-center text-[16px]/[24px] font-bold"
        style={{ color: recordBlockTextColor }}
      >
        {text}
      </p>
      <p
        className="text-center text-[56px]/[56px] font-bold"
        style={{ color: recordBlockTextColor, fontFamily: '\'Roboto\', sans-serif' }}
      >
        {count}
      </p>
    </div>
  )
}
